import type React from "react";

const STYLES = `
  @keyframes pmOverlayIn { from { opacity: 0; } to { opacity: 1; } }
  @keyframes pmFade {
    from { opacity: 0; transform: translateY(12px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes pmBarGrow {
    from { transform: scaleX(0); }
    to   { transform: scaleX(1); }
  }
  @keyframes pmAmbientBg {
    0%   { background-position: 35% 0%; }
    50%  { background-position: 65% 8%; }
    100% { background-position: 35% 0%; }
  }
  @keyframes pmOrb {
    0%   { transform: translate3d(-10%, -20%, 0) scale(1); opacity: 0.10; }
    50%  { transform: translate3d(40%, 10%, 0) scale(1.15); opacity: 0.16; }
    100% { transform: translate3d(-10%, -20%, 0) scale(1); opacity: 0.10; }
  }
  @keyframes pmOrb2 {
    0%   { transform: translate3d(60%, 30%, 0) scale(1.1); opacity: 0.35; }
    50%  { transform: translate3d(10%, 0%,  0) scale(1);    opacity: 0.5;  }
    100% { transform: translate3d(60%, 30%, 0) scale(1.1); opacity: 0.35; }
  }
  .pm-ambient-bg {
    position: fixed; inset: 0;
    background: radial-gradient(ellipse 80% 60% at 50% 0%, #1a1a1a 0%, #0a0a0a 55%, #000 100%);
    background-size: 160% 160%;
    animation: pmAmbientBg 28s ease-in-out infinite;
    pointer-events: none;
    z-index: 0;
  }
  .pm-orb {
    position: fixed;
    width: 55vw; height: 55vw;
    max-width: 900px; max-height: 900px;
    border-radius: 50%;
    filter: blur(120px);
    pointer-events: none;
    will-change: transform, opacity;
    z-index: 0;
  }
  .pm-orb-1 { top: -15%; left: 0;  background: #FFFFFF; animation: pmOrb  32s ease-in-out infinite; }
  .pm-orb-2 { top: 10%;  right: 0; background: #4C72B8; animation: pmOrb2 38s ease-in-out infinite; }
  .pm-content { position: relative; z-index: 1; }
  @media (prefers-reduced-motion: reduce) {
    .pm-ambient-bg, .pm-orb-1, .pm-orb-2 { animation: none; }
  }
`;

export function AmbientBackground(): React.JSX.Element {
  return (
    <>
      <style>{STYLES}</style>
      <div className="pm-ambient-bg" />
      <div className="pm-orb pm-orb-1" />
      <div className="pm-orb pm-orb-2" />
    </>
  );
}
